import React from 'react'
import '../../Work-css/Contacts.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faHashtag } from '@fortawesome/free-solid-svg-icons';


function Contacts({contacts}) {

  const x = () =>{
    contacts(false)
  }
  return (
    <div className='Contacts_BG_INNER'>
    <div className='close_tab_cont' onClick={x}>X</div>
    <div className='cont_details'><FontAwesomeIcon icon={faPhone} /> 0793 550 890</div>
    <div className='cont_details'><FontAwesomeIcon icon={faPhone} /> 0723 660 596</div>
    <div className='cont_details'><FontAwesomeIcon icon={faEnvelope} /> hosteladventures@gmail.com</div>
    <div className='cont_details'>
    Youtube: <a href='https://youtube.com/@hosteladventures1?si=NnWnrqem_dKwepfx'>Hostel Adventures</a></div>

    <div className='cont_details'>
    Instagram: <a href='https://www.instagram.com/hos.teladventures?igsh=MWVtYzdsdmMyYTNjZw=='>@HOSTELADVE369</a>
    </div>

    <div className='cont_details'>
    TikTok: <a href='https://vm.tiktok.com/ZMkaPdGVk/'>@hosteladventures</a>
    </div>

    
    </div>
  )
}

export default Contacts